import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUsers,
  FaClipboardList,
  FaBell,
  FaPowerOff,
  FaChevronUp,
  FaChevronDown,
  FaBars,
  FaAngleLeft,
} from "react-icons/fa";
import { BsPersonArmsUp, BsDatabaseFillCheck } from "react-icons/bs";
import { FaPersonWalkingDashedLineArrowRight } from "react-icons/fa6";
import {
  DASHBOARD,
  DATA_VERIFICATION,
  DESCRIPTION_MASTER,
  ENDS_MASTER,
  INSPECTION_LOC_MASTER,
  LOGIN,
  MANAGE_INSPECTOR,
  MANAGE_PROJECT,
  MANUFACTURER_MASTER,
  NOTIFICATION,
  SIZE_MASTER,
  SURFACE_MASTER,
  TYPE_MASTER,
  WELDING_MASTER,
  GLOBAL_SEARCH,
} from "../../utils/RouteConstant";
import { LOGIN_API } from "../../common/api";
import { axiosInstance } from "../../common/interceptor";
import { store } from "../../../redux/store/store";
import { logout } from "../../../redux/reducer/LoginReducer/LoginReducer";
import { Box, Modal, Tooltip } from "@mui/material";
import { RxCrossCircled } from "react-icons/rx";
import Danger from "../../../asesst/Danger.svg";
import admin_logo from "../../../asesst/admin_logo.svg";
import Company_Logo from "../../../asesst/Company_Logo.svg"
import { CiSearch } from "react-icons/ci";

const Sidebar = ({ currentPath }) => {
  const navigate = useNavigate();
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [isMasterOpen, setIsMasterOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleOpenLogoutModal = () => setOpenLogoutModal(true);
  const handleCloseLogoutModal = () => setOpenLogoutModal(false);
  const toggleMasterMenu = () => setIsMasterOpen(!isMasterOpen);
  const toggleSidebar = () => setIsCollapsed(!isCollapsed);
  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const handleLogout = async () => {
    try {
      const response = await axiosInstance.delete(`${LOGIN_API}`);
      if (response.status === 200) {
        console.log(response.data.message);
      }
    } catch (error) {
      console.error("Error logging out:", error);
    } finally {
      localStorage.clear();
      store.dispatch(logout());
      navigate(LOGIN);
    }
  };

  const navItems = [
    { path: DASHBOARD, icon: FaTachometerAlt, label: "Dashboard" },
    { path: MANAGE_INSPECTOR, icon: FaUsers, label: "User Management" },
    { path: MANAGE_PROJECT, icon: FaClipboardList, label: "Manage Project" },
    {
      path: DATA_VERIFICATION,
      icon: BsDatabaseFillCheck,
      label: "Data Verification",
    },
    {
      path: GLOBAL_SEARCH,
      icon: CiSearch,
      label: "Search",
    },
    { path: NOTIFICATION, icon: FaBell, label: "Notifications" },
    {
      icon: FaPersonWalkingDashedLineArrowRight,
      label: "Master",
      isMaster: true,
      submenu: [
        {
          path: DESCRIPTION_MASTER,
          icon: BsPersonArmsUp,
          label: "Description Master",
        },
        { path: SIZE_MASTER, icon: BsPersonArmsUp, label: "Size Master" },
        { path: ENDS_MASTER, icon: BsPersonArmsUp, label: "Ends Master" },
        { path: TYPE_MASTER, icon: BsPersonArmsUp, label: "Type Master" },
        { path: SURFACE_MASTER, icon: BsPersonArmsUp, label: "Surface Master" },
        {
          path: WELDING_MASTER,
          icon: BsPersonArmsUp,
          label: "Weld Additional Info",
        },
        {
          path: INSPECTION_LOC_MASTER,
          icon: BsPersonArmsUp,
          label: "Inspection Loc Master",
        },
        {
          path: MANUFACTURER_MASTER,
          icon: BsPersonArmsUp,
          label: "Manufacturer Master",
        },
      ],
    },
  ];

  const renderNavItem = (item) => {
    if (!item.isMaster) {
      return (
        <Tooltip title={isCollapsed ? item.label : ""} placement="right">
          <Link
            to={item.path}
            className={`flex items-center space-x-4 p-3 rounded-lg ${
              currentPath.startsWith(item.path)
                ? "bg-[#1C3664] text-white"
                : "hover:bg-gray-200 text-[#202224]"
            }`}
          >
            <item.icon className="text-xl" />
            {!isCollapsed && <span className="font-base">{item.label}</span>}
          </Link>
        </Tooltip>
      );
    }

    return (
      <>
        <Tooltip title={isCollapsed ? item.label : ""} placement="right">
          <button
            onClick={toggleMasterMenu}
            className={`flex items-center space-x-4 p-3 rounded-lg w-full ${
              currentPath.startsWith(item.path)
                ? "bg-[#1C3664] text-white"
                : "hover:bg-gray-200 text-[#202224]"
            }`}
          >
            <item.icon className="text-xl" />
            {!isCollapsed && (
              <>
                <span className="font-base">{item.label}</span>
                {isMasterOpen ? (
                  <FaChevronUp className="ml-auto" />
                ) : (
                  <FaChevronDown className="ml-auto" />
                )}
              </>
            )}
          </button>
        </Tooltip>
        {isMasterOpen && !isCollapsed && (
          <ul className="ml-8 mt-2 space-y-2">
            {item.submenu.map((submenuItem) => (
              <li key={submenuItem.path}>
                <Link
                  to={submenuItem.path}
                  className={`flex items-center space-x-4 p-2 rounded-lg ${
                    currentPath.startsWith(submenuItem.path)
                      ? "bg-[#1C3664] text-white"
                      : "hover:bg-gray-200 text-[#202224]"
                  }`}
                >
                  <submenuItem.icon className="text-xl" />
                  <span className="font-base">{submenuItem.label}</span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </>
    );
  };

  return (
    <>
      <button
        className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-gray-100"
        onClick={toggleMobileMenu}
      >
        <FaBars className="text-xl" />
      </button>

      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={toggleMobileMenu}
        />
      )}

      <div
        className={`fixed lg:relative inset-y-0 left-0 z-40 transition-all duration-300 transform bg-white shadow-lg
        ${isCollapsed ? "w-20" : "min-w-[240px]"}
        ${
          isMobileMenuOpen
            ? "translate-x-0"
            : "-translate-x-full lg:translate-x-0"
        }
        text-black h-screen flex flex-col`}
      >
        <button
          className="absolute -right-3 top-8 bg-white rounded-full p-1 shadow-md hidden lg:block"
          onClick={toggleSidebar}
        >
          <FaAngleLeft
            className={`text-xl transition-transform duration-300 ${
              isCollapsed ? "rotate-180" : ""
            }`}
          />
        </button>

        <div className={`p-4 ${isCollapsed ? "px-2" : ""}`}>
          <img
            src={isCollapsed ? Company_Logo : admin_logo}
            alt="logo"
            className={`mt-2 ${isCollapsed ? "w-10 mx-auto" : ""}`}
          />
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          <ul>
            {navItems.map((item) => (
              <li key={item.path || item.label}>{renderNavItem(item)}</li>
            ))}
          </ul>
        </div>

        <div className={`p-4 ${isCollapsed ? "px-2" : ""}`}>
          <Tooltip title={isCollapsed ? "Logout" : ""} placement="right">
            <button
              onClick={handleOpenLogoutModal}
              className={`w-full flex items-center justify-center p-2 rounded-lg bg-red-100 text-red-500 hover:bg-red-200 ${
                isCollapsed ? "px-1" : ""
              }`}
            >
              <FaPowerOff className="text-lg" />
              {!isCollapsed && (
                <span className="font-semibold ml-2">Logout</span>
              )}
            </button>
          </Tooltip>
        </div>

        <Modal
          open={openLogoutModal}
          className="justify-center items-center flex"
        >
          <Box className="bg-white text-center p-4 rounded-2xl shadow-md w-[90%] md:w-[40%] lg:w-[23%] mx-auto">
            <RxCrossCircled
              onClick={handleCloseLogoutModal}
              className="float-end top-2 h-6 w-6 cursor-pointer"
            />
            <div className="text-center inline-flex mt-8">
              <div className="flex items-center justify-center">
                <img src={Danger} alt="Success" className="w-full h-full" />
              </div>
            </div>
            <div className="text-center">
              <h2 className="text-3xl text-[#0B0B0B] mt-2 font-semibold">
                Are you leaving?
              </h2>
              <p className="font-normal text-lg mt-2 text-[#6D6D6D]">
                Are you sure you want to logout?
              </p>
            </div>
            <div className="flex justify-center space-x-6 my-6">
              <button
                onClick={handleLogout}
                className="bg-[#FFFFFF] border w-[70px] px-4 py-2 rounded-lg"
              >
                Yes
              </button>
              <button
                onClick={handleCloseLogoutModal}
                className="bg-[#1C3664] border w-[70px] text-white px-4 py-2 rounded-lg"
              >
                No
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
};
export default Sidebar;
